"use strict";
/**
 * @class MetaItemInlineEdit
 * @description Provides inline edit capability for meta item
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable jsx-no-multiline-js */
// this ^^ is required for the Form component
var React = require("react");
var Messages = require("../codegen/Messages");
var error_1 = require("../utils/error");
var MetaItems_1 = require("./MetaItems");
var index_1 = require("../index");
/**
 * OUI meta item inline edit component.
 *
 * @oui-component MetaItemInlineEdit
 */
var MetaItemInlineEdit = /** @class */ (function (_super) {
    __extends(MetaItemInlineEdit, _super);
    function MetaItemInlineEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editActive: false,
            loading: false,
            text: props.text,
            inputText: props.text
        };
        _this.setActive = _this.setActive.bind(_this);
        _this.setInactive = _this.setInactive.bind(_this);
        _this.submit = _this.submit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    MetaItemInlineEdit.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ text: nextProps.text });
    };
    MetaItemInlineEdit.prototype.setActive = function () {
        this.setState({
            editActive: true,
            errorString: undefined,
            inputText: this.props.text
        });
    };
    MetaItemInlineEdit.prototype.setInactive = function () {
        this.setState({
            editActive: false,
            loading: false,
            errorString: undefined,
            inputText: this.props.text
        });
    };
    MetaItemInlineEdit.prototype.onChange = function () {
        this.setState({ errorString: undefined, inputText: this.input.value });
    };
    MetaItemInlineEdit.prototype.submit = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var value, err_1, errorString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({
                            loading: true,
                            editActive: false,
                            errorString: undefined,
                            inputText: this.input.value
                        });
                        value = this.input.value.trim();
                        if (value === "") {
                            return [2 /*return*/, this.setState({
                                    loading: false,
                                    editActive: true,
                                    errorString: Messages.Common.required()
                                })];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.props.submitFunction(value)];
                    case 2:
                        _a.sent();
                        this.setState({ loading: false, editActive: false, text: value });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        return [4 /*yield*/, error_1.getErrorMessage(err_1)];
                    case 4:
                        errorString = _a.sent();
                        this.setState({ errorString: errorString, editActive: true, loading: false });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MetaItemInlineEdit.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, testId = _a.testId;
        var _b = this.state, editActive = _b.editActive, text = _b.text, errorString = _b.errorString, loading = _b.loading, inputText = _b.inputText;
        var propertyElement;
        if (editActive) {
            propertyElement = (React.createElement("form", { className: "oui-form-horizontal", onSubmit: this.submit },
                React.createElement("label", { className: "oui-form-label oui-text-bold", htmlFor: "value" },
                    label,
                    ":"),
                React.createElement("div", { className: "oui-form-controls" },
                    React.createElement("input", { type: "text", name: "value", className: "oui-input oui-width-auto", autoFocus: true, onChange: this.onChange, ref: function (input) { return (_this.input = input); }, defaultValue: inputText, "data-test-id": testId }),
                    React.createElement("button", { className: "hgds-inline-control hgds-confirm-control oui-button-link", onClick: function (e) {
                            _this.submit(e);
                            return;
                        }, "aria-label": "Confirm" },
                        React.createElement("svg", { version: "1.1", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", className: "hgds-inline-control-icon" },
                            React.createElement("path", { d: "M0 0h48v48h-48z", fill: "none" }),
                            React.createElement("path", { d: "M34 6h-24c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-24l-8-8zm-10 32c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm6-20h-20v-8h20v8z" }))),
                    React.createElement("button", { className: "hgds-inline-control hgds-cancel-control oui-button-link", onClick: this.setInactive, "aria-label": "Cancel" },
                        React.createElement("svg", { version: "1.1", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", className: "hgds-inline-control-icon" },
                            React.createElement("path", { d: "M4 8 L8 4 L16 12 L24 4 L28 8 L20 16 L28 24 L24 28 L16 20 L8 28 L4 24 L12 16 z" }))),
                    errorString && (React.createElement("div", { className: "oui-text-reserve oui-text-small oui-form-danger" }, errorString)))));
        }
        else {
            var valueElement = void 0;
            if (loading) {
                valueElement = React.createElement(index_1.Spinner, null);
            }
            else {
                valueElement = (React.createElement("span", null,
                    text,
                    React.createElement("button", { className: "hgds-inline-control hgds-edit-control oui-button-link", onClick: this.setActive, "data-test-id": testId },
                        React.createElement("svg", { className: "hgds-inline-control-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", version: "1.1", "aria-label": "Edit" },
                            React.createElement("g", { fillRule: "evenodd" },
                                React.createElement("g", { transform: "translate(-899.000000, -227.000000)" },
                                    React.createElement("g", { transform: "translate(215.000000, 119.000000)" }),
                                    React.createElement("path", { d: "M914.000027,248.002414 L914.000464,232.002414 L914.000464,232.002414 L907.001354,232.002414 L907.000079,248.002414 L914.000027,248.002414 Z M913.998311,249.002414 L910.501672,254 L907.00169,249.002414 L913.998311,249.002414 Z M914.000492,231.002414 L914.000574,228.002414 C914.000574,227 912.99816,227 912.99816,227 L908.004086,227 C908.004086,227 907.001672,227 907.001672,228.002414 L907.001433,231.002414 L914.000492,231.002414 L914.000492,231.002414 Z", transform: "translate(910.500326, 240.500000) rotate(45.000000) translate(-910.500326, -240.500000)" })))))));
            }
            propertyElement = (React.createElement(MetaItems_1.LabelMetaItem, { label: label }, valueElement));
        }
        return propertyElement;
    };
    return MetaItemInlineEdit;
}(React.Component));
exports.MetaItemInlineEdit = MetaItemInlineEdit;
//# sourceMappingURL=MetaItemInlineEdit.js.map